exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".api-sound{margin:10px;margin-bottom:64px}", ""]);

